import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
const BP_SM = 992;
const BP_MD = 992;
const BP_LG = 1200;
const widthPct = (n) => `${n / 12 * 100}%`;
const hasAnySize = ({ $xs, $sm, $md, $lg }) => $xs !== void 0 || $sm !== void 0 || $md !== void 0 || $lg !== void 0;
const StyledCol = styled.div`
  ${(p) => hasAnySize(p) && css`
      position: relative;
      min-height: 1px;
      padding-left: 15px;
      padding-right: 15px;
    `}

  ${({ $xs }) => $xs !== void 0 && css`
      float: left;
      width: ${widthPct($xs)};
    `}
  ${({ $xsOffset }) => $xsOffset !== void 0 && css`
      margin-left: ${widthPct($xsOffset)};
    `}
  ${({ $xsPush }) => $xsPush !== void 0 && css`
      left: ${widthPct($xsPush)};
    `}
  ${({ $xsPull }) => $xsPull !== void 0 && css`
      right: ${widthPct($xsPull)};
    `}
  ${({ $xsHidden }) => $xsHidden && css`
      @media (max-width: ${BP_SM - 1}px) {
        display: none !important;
      }
    `}

  @media (min-width: ${BP_SM}px) {
    ${({ $sm }) => $sm !== void 0 && css`
        float: left;
        width: ${widthPct($sm)};
      `}
    ${({ $smOffset }) => $smOffset !== void 0 && css`
        margin-left: ${widthPct($smOffset)};
      `}
    ${({ $smPush }) => $smPush !== void 0 && css`
        left: ${widthPct($smPush)};
      `}
    ${({ $smPull }) => $smPull !== void 0 && css`
        right: ${widthPct($smPull)};
      `}
  }

  @media (min-width: ${BP_MD}px) {
    ${({ $md }) => $md !== void 0 && css`
        float: left;
        width: ${widthPct($md)};
      `}
    ${({ $mdOffset }) => $mdOffset !== void 0 && css`
        margin-left: ${widthPct($mdOffset)};
      `}
    ${({ $mdPush }) => $mdPush !== void 0 && css`
        left: ${widthPct($mdPush)};
      `}
    ${({ $mdPull }) => $mdPull !== void 0 && css`
        right: ${widthPct($mdPull)};
      `}
  }
  ${({ $mdHidden }) => $mdHidden && css`
      @media (min-width: ${BP_MD}px) and (max-width: ${BP_LG - 1}px) {
        display: none !important;
      }
    `}

  @media (min-width: ${BP_LG}px) {
    ${({ $lg }) => $lg !== void 0 && css`
        float: left;
        width: ${widthPct($lg)};
      `}
    ${({ $lgOffset }) => $lgOffset !== void 0 && css`
        margin-left: ${widthPct($lgOffset)};
      `}
    ${({ $lgPush }) => $lgPush !== void 0 && css`
        left: ${widthPct($lgPush)};
      `}
    ${({ $lgPull }) => $lgPull !== void 0 && css`
        right: ${widthPct($lgPull)};
      `}
  }
  ${({ $lgHidden }) => $lgHidden && css`
      @media (min-width: ${BP_LG}px) {
        display: none !important;
      }
    `}
`;
const Col = ({
  xs = void 0,
  sm = void 0,
  md = void 0,
  lg = void 0,
  xsOffset = void 0,
  smOffset = void 0,
  mdOffset = void 0,
  lgOffset = void 0,
  xsPush = void 0,
  smPush = void 0,
  mdPush = void 0,
  lgPush = void 0,
  xsPull = void 0,
  smPull = void 0,
  mdPull = void 0,
  lgPull = void 0,
  xsHidden = false,
  // `sm` resolves to the same breakpoint as `md` in this project's RB
  // config, and the .hidden-sm media query (min-width: 992px and
  // max-width: 991px) is an empty range — so `smHidden` is a no-op
  // visually, matching what Bootstrap renders.
  smHidden = false,
  mdHidden = false,
  lgHidden = false,
  componentClass = void 0,
  className = void 0,
  style = void 0,
  id = void 0,
  children = void 0,
  "data-testid": dataTestid = void 0
}, ref) => {
  void smHidden;
  return /* @__PURE__ */ React.createElement(
    StyledCol,
    {
      ref,
      as: componentClass,
      $xs: xs,
      $sm: sm,
      $md: md,
      $lg: lg,
      $xsOffset: xsOffset,
      $smOffset: smOffset,
      $mdOffset: mdOffset,
      $lgOffset: lgOffset,
      $xsPush: xsPush,
      $smPush: smPush,
      $mdPush: mdPush,
      $lgPush: lgPush,
      $xsPull: xsPull,
      $smPull: smPull,
      $mdPull: mdPull,
      $lgPull: lgPull,
      $xsHidden: xsHidden,
      $mdHidden: mdHidden,
      $lgHidden: lgHidden,
      className,
      style,
      id,
      "data-testid": dataTestid
    },
    children
  );
};
export default forwardRef(Col);
